import React, { useEffect } from "react";
import { PaymentWrapper, RedirectionText } from "./styles";
import DynamicLottie from "@components/common/Lottie/LottieAnimation";
import { fetchConfigAndRedirect } from "@actions/fetchConfigRedirect";
import { useRouter } from "next/router";
import { consolelog } from "@service/apiServices";
import { sampleAnalytics } from "@utils/index";

const PaymentData = (props) => {
  const reservedProps = props;
  const { payment_attributes } = props;
  const { redirection_url } = payment_attributes;

  const router = useRouter();
  const { current_node, proposal_ekey } = router?.query;
  sampleAnalytics(
    "view_page_payment_intermediate",
    "view_modal",
    "view_page_payment_intermediate_global",
    {
      current_node: current_node,
      debugging: router?.query
    }
  );

  useEffect(() => {
    consolelog(`SDUI payment page loaded ${current_node} : ${proposal_ekey}`);
    sampleAnalytics(
      "view_page_payment_intermediate",
      "view_modal",
      "view_page_payment_intermediate",
      {
        current_node: current_node,
        debugging: router?.query,
        props: reservedProps
      }
    );
    if (redirection_url) {
      consolelog(
        `SDUI payment page replaced ${current_node} : ${proposal_ekey}`
      );
      window.location.replace(redirection_url);
      sampleAnalytics(
        "view_page_payment_intermediate",
        "view_modal",
        "view_page_payment_redirection",
        {
          current_node: current_node,
          debugging: router?.query,
          props: reservedProps
        }
      );
    } else {
      consolelog(
        `SDUI payment page else loaded ${current_node} : ${proposal_ekey}`
      );

      // Redirect user to review screen
      const payload = {
        requestBody: {
          current_node: current_node,
          expected_node: "checkout_review_node"
        },
        data: {
          proposal_ekey: proposal_ekey
        }
      };
      sampleAnalytics(
        "view_page_payment_intermediate",
        "view_modal",
        "view_page_payment_fallback_in_else",
        {
          current_node: current_node,
          debugging: router?.query,
          payload: payload,
          props: reservedProps
        }
      );

      fetchConfigAndRedirect(payload);
    }
  }, [redirection_url]);

  return (
    <div>
      <PaymentWrapper>
        <DynamicLottie />
        <RedirectionText>Redirecting to payment gateway...</RedirectionText>
      </PaymentWrapper>
    </div>
  );
};

export default PaymentData;
